const SURAT_KARGO_OTP_TYPES = new Set([
  'suratkargootp',
  'surat_kargo_otp',
  'surat-kargo-otp',
]);

function normalizeValue(value) {
  if (value === null || value === undefined) return '';
  return String(value).trim().toLowerCase();
}

function collectPrimitiveValues(value, values = []) {
  if (Array.isArray(value)) {
    value.forEach((item) => collectPrimitiveValues(item, values));
    return values;
  }

  if (value && typeof value === 'object') {
    Object.entries(value).forEach(([key, item]) => {
      values.push(key);
      collectPrimitiveValues(item, values);
    });
    return values;
  }

  values.push(value);
  return values;
}

export function getOtpTypeForPost(post, enteredOtp) {
  if (post?.deliveryPasswordType === 'hashBased') {
    console.log('[postOtpType] hashBased delivery detected, using TrendyolOTP', {
      barcode: post?.barcode,
      postID: post?.id,
      deliveryPasswordType: post?.deliveryPasswordType,
    });
    return 'TrendyolOTP';
  }

  const normalizedOtp = normalizeValue(enteredOtp);
  if (!normalizedOtp) {
    console.log('[postOtpType] empty OTP input, defaulting to EasypointOTP', {
      barcode: post?.barcode,
      postID: post?.id,
      enteredOtp,
    });
    return 'EasypointOTP';
  }

  const flattenedValues = collectPrimitiveValues(post?.dataJSON);
  const isSuratKargoOtp = flattenedValues.some((value) => {
    const normalizedValue = normalizeValue(value);
    return (
      normalizedValue === normalizedOtp ||
      SURAT_KARGO_OTP_TYPES.has(normalizedValue)
    );
  });

  console.log('[postOtpType] OTP type resolved', {
    barcode: post?.barcode,
    postID: post?.id,
    apiUserType: post?.apiUserType,
    enteredOtp,
    normalizedOtp,
    matchedDataJsonValue: isSuratKargoOtp,
    resolvedOtpType: isSuratKargoOtp ? 'SuratKargoOTP' : 'EasypointOTP',
  });

  return isSuratKargoOtp ? 'SuratKargoOTP' : 'EasypointOTP';
}
